import React from "react";

import "./src/styles/global.css";
import Layout from "./src/components/Layout";
import AdminLayout from "./src/components/AdminLayout";
import LoginLayout from "./src/components/LoginLayout";
import IntentPopup from "./src/components/IntentPopup";

// Wraps every page in a component
export const wrapPageElement = ({ element, props }) => {
  const path = props.path || "";

  // Use AdminLayout for admin pages
  if (path.startsWith("/admin")) {
    return <AdminLayout {...props}>{element}</AdminLayout>;
  }

  // Use LoginLayout for login page
  if (path === "/login" || path === "/login/") {
    return <LoginLayout {...props}>{element}</LoginLayout>;
  }

  // Show IntentPopup on all pages except the landing page
  const showIntentPopup = path !== "/" && path !== "";

  // Use regular Layout for all other pages
  return (
    <Layout {...props}>
      {element}
      {showIntentPopup && <IntentPopup />}
    </Layout>
  );
};
